import { call, fork, select, takeLatest } from 'redux-saga/effects';

import { findMembers } from '../api';

import { membersListActions } from './actions';

import { getMembersListById } from './selectors';

export function* findMembersList({payload}) {
  const { membersListId, filters } = payload;

  const membersList = yield select(getMembersListById, membersListId);

  if (membersList && membersList.isNew ){
    yield call(findMembers, membersListId, filters);
  }

}

export function* findMembersById({payload}) {
  const { membersListId } = payload;

  const membersList = yield select(getMembersListById, membersListId);

}


//=====================================
//  WATCHERS
//-------------------------------------

export function* watchFinMembersList() {
  yield takeLatest(membersListActions.FIND_MEMBERS, findMembersList);
}

export function* watchFinMembersById() {
  yield takeLatest(membersListActions.FIND_MEMBERS_BY_ID, findMembersById);
}



//=====================================
//  ROOT
//-------------------------------------

export const membersListSagas = [
  fork(watchFinMembersList),
  fork(watchFinMembersById),
];
